import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Search = createSvgIcon(
  <path d="M15.375 16.966A9.46 9.46 0 0 1 9.5 19 9.5 9.5 0 1 1 19 9.5a9.46 9.46 0 0 1-2.034 5.875l7.012 7.012-1.59 1.591-7.013-7.012ZM16.75 9.5a7.25 7.25 0 1 0-14.5 0 7.25 7.25 0 0 0 14.5 0Z" />,
  'Search'
);

export { Search };